import AboutMain from "./AboutMe/AboutMain.jsx";
import HeroSection from "./Hero/home.jsx";
import Portfolio from "./Portfolio/Portfolio.jsx";
import Section2 from "./Section2/Section2.jsx";
import ContactMe from "./contactMe/ContactMe.jsx";
import Footer from "./main/Footer.jsx";
import Nav from "./main/Nav.jsx"

export default function App(){
  return(
    <div className="relative overflow-hidden bg-gradient-to-r from-[#F8CE89] to-[#578CA3]">
        <Nav/>
        <HeroSection/>
        <Section2/>
        <AboutMain/>
        <Portfolio/>
        <ContactMe/>
        <Footer/>
    </div>
  )
}